export type DemoPriorityAction = {
  id: string;
  priority: number;
  stageChip?: "HOT" | "WARM" | "STALE";
  valueLabel?: string;
  title: string;
  whyNow: string;
  overdueLabel?: string;
  riskLabel?: string;
  actions: Array<"Done" | "Send to phone" | "Call" | "WhatsApp">;
};

export const mockTodayActions: DemoPriorityAction[] = [
  {
    id: "Aa20BDe68eAb0e9",
    priority: 1,
    stageChip: "HOT",
    valueLabel: "€4.8K",
    title: "Why now: First touch overdue by 38h. Cooling accelerating.",
    overdueLabel: "Overdue by 38h",
    riskLabel: "At risk: overdue follow-up • At risk: never contacted",
    whyNow: "Top priority — revenue impact + time decay.",
    actions: ["Done", "Send to phone", "Call", "WhatsApp"],
  },
  {
    id: "c09952De6Cda8aA",
    priority: 2,
    stageChip: "WARM",
    valueLabel: "€2.34K",
    title: "Why now: Follow-up overdue by 38h. Risk is increasing.",
    overdueLabel: "Overdue by 38h",
    riskLabel: "At risk: overdue follow-up • €2K deal",
    whyNow: "Second priority — keep momentum before it stalls.",
    actions: ["Done", "Send to phone", "Call", "WhatsApp"],
  },
  {
    id: "FCBfCEAe20A8DC",
    priority: 3,
    stageChip: "STALE",
    valueLabel: "€1.1K",
    title: "Why now: Stale lead. Attempt a reactivation or close-loop.",
    overdueLabel: "Overdue by 22h",
    riskLabel: "At risk: never contacted • Late stage",
    whyNow: "Third priority — clean pipeline and recover value.",
    actions: ["Done", "Send to phone", "Call", "WhatsApp"],
  },
];
